import React from 'react';
import { AlertDialog, Button } from '@economic/taco';
import { Trans } from '@lingui/macro';

interface CancelStepProps {
    onCancel: () => void;
    onContinue: () => void;
}

export const CancelStep: React.FC<CancelStepProps> = ({ onCancel, onContinue }) => {
    return (
        <AlertDialog defaultOpen>
            <AlertDialog.Content aria-label="Cancel payroll onboarding">
                <AlertDialog.Title>
                    <Trans>Cancel payroll onboarding</Trans>
                </AlertDialog.Title>
                <div className="my-6">
                    <p className="text-grey-700 m-0">
                        <Trans>Are you sure you want to close?</Trans>
                        <br />
                        <Trans>You won't be able to enter the payroll system without completing the onboarding steps.</Trans>
                    </p>
                </div>
                <AlertDialog.Footer>
                    <AlertDialog.Action>
                        <Button onClick={onCancel}>
                            <Trans>Close anyway</Trans>
                        </Button>
                    </AlertDialog.Action>
                    <AlertDialog.Cancel>
                        <Button appearance="primary" onClick={onContinue}>
                            <Trans>Continue the onboarding</Trans>
                        </Button>
                    </AlertDialog.Cancel>
                </AlertDialog.Footer>
            </AlertDialog.Content>
        </AlertDialog>
    );
};
